import React from 'react';

const OurStory: React.FC = () => {
  return (
    <section id="our-story" className="py-12 md:py-20 bg-wedding-cream">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl text-center text-wedding-navy mb-8 md:mb-16">
          Our Love Story
        </h2>

        <div className="max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center mb-12 md:mb-16">
            <div className="relative px-4 md:px-0">
              <img
                src="/images/save-the-date/001-savethedate.jpg"
                alt="Nelisa and Jesse"
                className="rounded-lg shadow-2xl w-full"
              />
              <div className="hidden md:block absolute -bottom-6 -right-6 w-32 h-32 border-4 border-wedding-gold rounded-lg -z-10"></div>
            </div>
            <div className="px-2">
              <h3 className="font-serif text-xl sm:text-2xl md:text-3xl text-wedding-gold mb-3 md:mb-4">How We Met</h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                We met  at KFC, apparently true love doesn’t need a fancy setting, just the right timing. 
                We were just kids figuring life out and didn’t have much, but we had each other. 
                We grew up together, learned through mistakes, and held on through the hard times as much as the good. 
                Along the way, we became parents to our two amazing boys, Jaylen and Jayce, who taught us what real love and commitment mean. 
                After all these years, this moment feels earned. 
                We’re still choosing each other, still growing, and excited to keep building our life together forever.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6 md:gap-12 items-center mb-12 md:mb-16">
            <div className="order-2 md:order-1 px-2">
              <h3 className="font-serif text-xl sm:text-2xl md:text-3xl text-wedding-gold mb-3 md:mb-4">The Proposal</h3>
              <p className="text-gray-700 leading-relaxed text-sm sm:text-base">
                Jesse planned the perfect proposal, knowing that Nelisa deserved nothing
                less than a moment as beautiful as our love. With hearts full of joy and
                tears of happiness, we said yes to forever together.
              </p>
            </div>
            <div className="relative order-1 md:order-2 px-4 md:px-0">
              <img
                src="/images/engagement/092-engagement.jpg"
                alt="The Proposal"
                className="rounded-lg shadow-2xl w-full"
                style={{
                  imageRendering: '-webkit-optimize-contrast',
                  backfaceVisibility: 'hidden',
                  transform: 'translateZ(0)',
                }}
              />
              <div className="hidden md:block absolute -top-6 -left-6 w-32 h-32 border-4 border-wedding-gold rounded-lg -z-10"></div>
            </div>
          </div>

          <div className="text-center px-2">
            <div className="inline-block bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-lg">
              <p className="font-serif text-base sm:text-lg md:text-xl lg:text-2xl text-wedding-navy mb-2">
                And now we can't wait to celebrate
              </p>
              <p className="text-wedding-gold text-sm sm:text-base md:text-lg lg:text-xl">with all of you in paradise!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurStory;
